import toggleAttachmentGroup from './toggle-attachment-group'

export default function (table) {
  const $groupCheck = table.find('tr.level_0 .export-account-check input')
  const $allInputsInGroup = table.find('tr.level_1 .export-account-check input')
  const $checkedInputsInGroup = table.find(
    'tr.level_1 .export-account-check input:checked'
  )

  $groupCheck.prop(
    'checked',
    $allInputsInGroup.length === $checkedInputsInGroup.length
  )

  return toggleAttachmentGroup(table)
}
